(function () {
  if (window.TMGCareersSectionsLoaded) return;
  window.TMGCareersSectionsLoaded = true;

  function setAccordionState(trigger, expanded) {
    trigger.setAttribute('aria-expanded', expanded ? 'true' : 'false');
  }

  function showSlide(carousel, index) {
    var slides = Array.prototype.slice.call(carousel.querySelectorAll('[data-careers-slide]'));
    var dots = Array.prototype.slice.call(carousel.querySelectorAll('[data-careers-dot]'));
    if (!slides.length) return;

    var nextIndex = ((index % slides.length) + slides.length) % slides.length;
    carousel.dataset.activeIndex = String(nextIndex);

    slides.forEach(function (slide, slideIndex) {
      var active = slideIndex === nextIndex;
      slide.classList.toggle('is-active', active);
      slide.hidden = !active;
    });

    dots.forEach(function (dot, dotIndex) {
      var active = dotIndex === nextIndex;
      dot.classList.toggle('is-active', active);
      dot.setAttribute('aria-current', active ? 'true' : 'false');
    });
  }

  document.addEventListener('click', function (event) {
    var accordionTrigger = event.target.closest('[data-careers-accordion-trigger]');
    if (accordionTrigger) {
      setAccordionState(accordionTrigger, accordionTrigger.getAttribute('aria-expanded') !== 'true');
      return;
    }

    var control = event.target.closest('[data-careers-carousel-control]');
    if (control) {
      var carousel = control.closest('[data-careers-carousel]');
      var current = Number(carousel.dataset.activeIndex || 0);
      showSlide(carousel, current + Number(control.dataset.careersCarouselControl));
      return;
    }

    var dot = event.target.closest('[data-careers-dot]');
    if (dot) {
      showSlide(dot.closest('[data-careers-carousel]'), Number(dot.dataset.careersDot));
    }
  });

  document.addEventListener('shopify:block:select', function (event) {
    var block = event.target;
    var accordionTrigger = block.querySelector('[data-careers-accordion-trigger]');
    if (accordionTrigger) setAccordionState(accordionTrigger, true);

    var slide = block.matches('[data-careers-slide]') ? block : block.querySelector('[data-careers-slide]');
    if (slide) {
      var carousel = slide.closest('[data-careers-carousel]');
      var slides = Array.prototype.slice.call(carousel.querySelectorAll('[data-careers-slide]'));
      showSlide(carousel, slides.indexOf(slide));
    }
  });
})();
